
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _404PageHx53ezi0IDMeta } from "/src/src/pages/404/ui/404Page.vue?macro=true";
import { default as AddressPagex5In9LltFQMeta } from "/src/src/pages/address/ui/AddressPage.vue?macro=true";
import { default as PermissionsPagevX2Xu65PWWMeta } from "/src/src/pages/admin/permissions/ui/PermissionsPage.vue?macro=true";
import { default as consttkcLOPIr5UMeta } from "/src/src/pages/admin/reports/supporters/model/const.ts?macro=true";
import { default as reports_45constazOqMUWt1PMeta } from "/src/src/pages/admin/reports/supporters/model/reports-const.ts?macro=true";
import { default as DetailReportsPageaH0kvE93M7Meta } from "/src/src/pages/admin/reports/supporters/ui/DetailReportsPage.vue?macro=true";
import { default as FormTemplatePage9VqOA2CkxzMeta } from "/src/src/pages/admin/reports/supporters/ui/FormTemplatePage.vue?macro=true";
import { default as ProjectsReportPage9scB3sCeMiMeta } from "/src/src/pages/admin/reports/supporters/ui/ProjectsReportPage.vue?macro=true";
import { default as ReportsPagekIIjKd8C0QMeta } from "/src/src/pages/admin/reports/supporters/ui/ReportsPage.vue?macro=true";
import { default as SendMessagePagem5C8T3fc3ZMeta } from "/src/src/pages/admin/reports/supporters/ui/SendMessagePage.vue?macro=true";
import { default as SupportersReportPageKIVXbEc0L1Meta } from "/src/src/pages/admin/reports/supporters/ui/SupportersReportPage.vue?macro=true";
import { default as TemplateReport7qqRzQKeTJMeta } from "/src/src/pages/admin/reports/supporters/ui/TemplateReport.vue?macro=true";
import { default as TemplatesReportPage9qVezoGtZqMeta } from "/src/src/pages/admin/reports/supporters/ui/TemplatesReportPage.vue?macro=true";
import { default as ForgotPasswordPagesKtNWSgPqOMeta } from "/src/src/pages/auth/forgot-password/ui/ForgotPasswordPage.vue?macro=true";
import { default as HomePage89UwthSvNNMeta } from "/src/src/pages/auth/home/ui/HomePage.vue?macro=true";
import { default as PinSetupPagehzYXxX29acMeta } from "/src/src/pages/auth/pin-setup/ui/PinSetupPage.vue?macro=true";
import { default as PinUnlockPageVrikbZQludMeta } from "/src/src/pages/auth/pin-unlock/ui/PinUnlockPage.vue?macro=true";
import { default as ProfilePagexNyjMbRAV4Meta } from "/src/src/pages/auth/profile/ui/ProfilePage.vue?macro=true";
import { default as SetPasswordPagejdW7eqc25cMeta } from "/src/src/pages/auth/set-password/ui/SetPasswordPage.vue?macro=true";
import { default as SigninPagegQZ0j1bGEjMeta } from "/src/src/pages/auth/signin/ui/SigninPage.vue?macro=true";
import { default as SignupPageQf8sR8Xu0zMeta } from "/src/src/pages/auth/signup/ui/SignupPage.vue?macro=true";
import { default as SuccessPagei5pgpGFT06Meta } from "/src/src/pages/auth/success/ui/SuccessPage.vue?macro=true";
import { default as VerifyPagefJOt7jzCAeMeta } from "/src/src/pages/auth/verify/ui/VerifyPage.vue?macro=true";
import { default as calendarTaskInvitationsFiltervz2Vy7HtPIMeta } from "/src/src/pages/calendar/model/calendarTaskInvitationsFilter.ts?macro=true";
import { default as calendarTaskInvitationsMockByibJLIBXWMeta } from "/src/src/pages/calendar/model/calendarTaskInvitationsMock.ts?macro=true";
import { default as CalendarPagen2P4VVUujMMeta } from "/src/src/pages/calendar/ui/CalendarPage.vue?macro=true";
import { default as CalendarTaskCommentsPage0gOGJuZI0KMeta } from "/src/src/pages/calendar/ui/CalendarTaskCommentsPage.vue?macro=true";
import { default as CalendarTaskInvitationsFilterPopup7Y3dBXZc4RMeta } from "/src/src/pages/calendar/ui/CalendarTaskInvitationsFilterPopup.vue?macro=true";
import { default as CalendarTaskInvitationsPageErW54zVetMMeta } from "/src/src/pages/calendar/ui/CalendarTaskInvitationsPage.vue?macro=true";
import { default as CalendarTaskParticipantsPagerVl6RihEErMeta } from "/src/src/pages/calendar/ui/CalendarTaskParticipantsPage.vue?macro=true";
import { default as useCommentsThreadhRytKSu4i9Meta } from "/src/src/pages/comments/model/useCommentsThread.ts?macro=true";
import { default as CommentsPageYOUaniBmIrMeta } from "/src/src/pages/comments/ui/CommentsPage.vue?macro=true";
import { default as CommentsThreadPanelwAghuNvMMdMeta } from "/src/src/pages/comments/ui/CommentsThreadPanel.vue?macro=true";
import { default as OpenSourcePageR62ipQyh5eMeta } from "/src/src/pages/docs/open-source/ui/OpenSourcePage.vue?macro=true";
import { default as ReestrDocsPagekCjdrQNIMRMeta } from "/src/src/pages/docs/reestr-po/ui/ReestrDocsPage.vue?macro=true";
import { default as constxYyLkWa66tMeta } from "/src/src/pages/documents/model/const.ts?macro=true";
import { default as DocumentsFormPage1J2CbjWUkMMeta } from "/src/src/pages/documents/ui/DocumentsFormPage.vue?macro=true";
import { default as DocumentsPageKXPW0AmyUkMeta } from "/src/src/pages/documents/ui/DocumentsPage.vue?macro=true";
import { default as ForbiddenPageIYRNBpLK6aMeta } from "/src/src/pages/forbidden/ui/ForbiddenPage.vue?macro=true";
import { default as consta6p7i1VXp1Meta } from "/src/src/pages/friends/model/const.ts?macro=true";
import { default as FriendsPagecllNkZBet5Meta } from "/src/src/pages/friends/ui/FriendsPage.vue?macro=true";
import { default as IndexPage8GV9K0mUVjMeta } from "/src/src/pages/index/ui/IndexPage.vue?macro=true";
import { default as InternetPagepf8BZJMRgyMeta } from "/src/src/pages/internet/ui/InternetPage.vue?macro=true";
import { default as indexcARU0PrrgeMeta } from "/src/src/pages/legal/advertising/index.ts?macro=true";
import { default as AdvertisingPageO5EwjaR1QZMeta } from "/src/src/pages/legal/advertising/ui/AdvertisingPage.vue?macro=true";
import { default as index1lgqrYfbeOMeta } from "/src/src/pages/legal/consent/index.ts?macro=true";
import { default as ConsentPagenJuSme54sJMeta } from "/src/src/pages/legal/consent/ui/ConsentPage.vue?macro=true";
import { default as indexZw0B7fG204Meta } from "/src/src/pages/legal/cookies/index.ts?macro=true";
import { default as CookiesPageobanI7ES6WMeta } from "/src/src/pages/legal/cookies/ui/CookiesPage.vue?macro=true";
import { default as index7BU3PEvIHnMeta } from "/src/src/pages/legal/privacy/index.ts?macro=true";
import { default as PrivacyPageZ8sRIVRMk7Meta } from "/src/src/pages/legal/privacy/ui/PrivacyPage.vue?macro=true";
import { default as LoadPageGIg7pryXpOMeta } from "/src/src/pages/load/ui/LoadPage.vue?macro=true";
import { default as const6TY0DugV1CMeta } from "/src/src/pages/mail/model/const.ts?macro=true";
import { default as useMailFormX2pLKubEEwMeta } from "/src/src/pages/mail/model/useMailForm.ts?macro=true";
import { default as useMailItemfLksGiYAhqMeta } from "/src/src/pages/mail/model/useMailItem.ts?macro=true";
import { default as useMailRecipients1cwCfIHLF1Meta } from "/src/src/pages/mail/model/useMailRecipients.ts?macro=true";
import { default as MailAppealPageLat4Efn9XEMeta } from "/src/src/pages/mail/ui/MailAppealPage.vue?macro=true";
import { default as MailCreatePagechqe3OJUiXMeta } from "/src/src/pages/mail/ui/MailCreatePage.vue?macro=true";
import { default as MailDetailPageupHjgeSMj9Meta } from "/src/src/pages/mail/ui/MailDetailPage.vue?macro=true";
import { default as MailPageCvRRXHrAMtMeta } from "/src/src/pages/mail/ui/MailPage.vue?macro=true";
import { default as MailReplyPageCKqFvXYqieMeta } from "/src/src/pages/mail/ui/MailReplyPage.vue?macro=true";
import { default as constdgwKlKj81MMeta } from "/src/src/pages/news/model/const.ts?macro=true";
import { default as MediaInsertFieldrBIS2L5gzoMeta } from "/src/src/pages/news/ui/MediaInsertField.vue?macro=true";
import { default as MySpeechReorderPageZKFhRDTGKFMeta } from "/src/src/pages/news/ui/MySpeechReorderPage.vue?macro=true";
import { default as MySpeechReviewPageNpHudwlLjlMeta } from "/src/src/pages/news/ui/MySpeechReviewPage.vue?macro=true";
import { default as NewsDetailPageSAiGax0T9BMeta } from "/src/src/pages/news/ui/NewsDetailPage.vue?macro=true";
import { default as NewsFormPageKQB9TCKzzqMeta } from "/src/src/pages/news/ui/NewsFormPage.vue?macro=true";
import { default as NewsPageToUd82BS6HMeta } from "/src/src/pages/news/ui/NewsPage.vue?macro=true";
import { default as NewsSelectionProjectPageqax8YNszqcMeta } from "/src/src/pages/news/ui/NewsSelectionProjectPage.vue?macro=true";
import { default as NotificationSettingsPageWtirgEUd1mMeta } from "/src/src/pages/notification-settings/ui/NotificationSettingsPage.vue?macro=true";
import { default as constmy8cqvIJ2PMeta } from "/src/src/pages/notifications/model/const.ts?macro=true";
import { default as NotificationsPageUxTpgerOLVMeta } from "/src/src/pages/notifications/ui/NotificationsPage.vue?macro=true";
import { default as PushNotificationsPagePOV39AsQf6Meta } from "/src/src/pages/notifications/ui/PushNotificationsPage.vue?macro=true";
import { default as ProfilePage7JAsnyUXwbMeta } from "/src/src/pages/profile/ui/ProfilePage.vue?macro=true";
import { default as indexepa2c6atVSMeta } from "/src/src/pages/projects/index.ts?macro=true";
import { default as constA0lO0oNdpJMeta } from "/src/src/pages/projects/model/const.ts?macro=true";
import { default as filterManagementBuiltinModulesForProjectWorkspace8KuS5B5meiMeta } from "/src/src/pages/projects/model/filterManagementBuiltinModulesForProjectWorkspace.ts?macro=true";
import { default as projectsFilterrPzp6RzrH7Meta } from "/src/src/pages/projects/model/projectsFilter.ts?macro=true";
import { default as projectsListScrollT85QZqLgraMeta } from "/src/src/pages/projects/model/projectsListScroll.ts?macro=true";
import { default as ProfileMyTeamPageZVXXIzwSaGMeta } from "/src/src/pages/projects/ui/ProfileMyTeamPage.vue?macro=true";
import { default as ProjectEditPageVSCKOFkAjpMeta } from "/src/src/pages/projects/ui/ProjectEditPage.vue?macro=true";
import { default as ProjectFormPage1azSYaoOzsMeta } from "/src/src/pages/projects/ui/ProjectFormPage.vue?macro=true";
import { default as ProjectLandingModuleSelectPagehxcumNW7mqMeta } from "/src/src/pages/projects/ui/ProjectLandingModuleSelectPage.vue?macro=true";
import { default as ProjectPage5fGGctjCQwMeta } from "/src/src/pages/projects/ui/ProjectPage.vue?macro=true";
import { default as ProjectRequestApprovePagejF4x32qOirMeta } from "/src/src/pages/projects/ui/ProjectRequestApprovePage.vue?macro=true";
import { default as ProjectsAllPage1GiUQyzImVMeta } from "/src/src/pages/projects/ui/ProjectsAllPage.vue?macro=true";
import { default as ProjectsFavoritePagenQ4V58Csb5Meta } from "/src/src/pages/projects/ui/ProjectsFavoritePage.vue?macro=true";
import { default as ProjectsFilterPopupDTX9rgR4G7Meta } from "/src/src/pages/projects/ui/ProjectsFilterPopup.vue?macro=true";
import { default as ProjectsMyPage37DBb0w8s1Meta } from "/src/src/pages/projects/ui/ProjectsMyPage.vue?macro=true";
import { default as ProjectsPageDE1MILgyX4Meta } from "/src/src/pages/projects/ui/ProjectsPage.vue?macro=true";
import { default as ProjectsRequestsPagebx0fPFxcRkMeta } from "/src/src/pages/projects/ui/ProjectsRequestsPage.vue?macro=true";
import { default as ProjectsWorkspaceCountersDetailPagezm5hC4D6BlMeta } from "/src/src/pages/projects/ui/ProjectsWorkspaceCountersDetailPage.vue?macro=true";
import { default as ProjectsWorkspaceCountersHistoryPageghHlX7fiu4Meta } from "/src/src/pages/projects/ui/ProjectsWorkspaceCountersHistoryPage.vue?macro=true";
import { default as ProjectsWorkspaceCountersPage76t7m1EpxbMeta } from "/src/src/pages/projects/ui/ProjectsWorkspaceCountersPage.vue?macro=true";
import { default as ProjectsWorkspaceManagementModuleDetailPage5rlhliqVsQMeta } from "/src/src/pages/projects/ui/ProjectsWorkspaceManagementModuleDetailPage.vue?macro=true";
import { default as ProjectsWorkspaceManagementModulePagelOseXl2zWeMeta } from "/src/src/pages/projects/ui/ProjectsWorkspaceManagementModulePage.vue?macro=true";
import { default as ProjectsWorkspaceManagementMyTeamPagesJqkaGogChMeta } from "/src/src/pages/projects/ui/ProjectsWorkspaceManagementMyTeamPage.vue?macro=true";
import { default as ProjectsWorkspaceManagementSettingsPage0jbJv84YDhMeta } from "/src/src/pages/projects/ui/ProjectsWorkspaceManagementSettingsPage.vue?macro=true";
import { default as ProjectTemplatePageZqWZssk0zoMeta } from "/src/src/pages/projects/ui/ProjectTemplatePage.vue?macro=true";
import { default as ProjectWorkspaceEmergencyContactsCategoryPage2zMw2QHkuBMeta } from "/src/src/pages/projects/ui/ProjectWorkspaceEmergencyContactsCategoryPage.vue?macro=true";
import { default as ProjectWorkspaceEmergencyContactsPageZM7miZd00jMeta } from "/src/src/pages/projects/ui/ProjectWorkspaceEmergencyContactsPage.vue?macro=true";
import { default as ProjectWorkspaceMembersInvitePageVNAT55kNWdMeta } from "/src/src/pages/projects/ui/ProjectWorkspaceMembersInvitePage.vue?macro=true";
import { default as ProjectWorkspaceMembersPageGRDXNfniXwMeta } from "/src/src/pages/projects/ui/ProjectWorkspaceMembersPage.vue?macro=true";
import { default as ProjectWorkspacePage36MhaBP126Meta } from "/src/src/pages/projects/ui/ProjectWorkspacePage.vue?macro=true";
import { default as ProjectWorkspacePresetSelectPagePYEcXeCl1uMeta } from "/src/src/pages/projects/ui/ProjectWorkspacePresetSelectPage.vue?macro=true";
import { default as ProjectWorkspaceSupportersFormPageM6TpyTc70KMeta } from "/src/src/pages/projects/ui/ProjectWorkspaceSupportersFormPage.vue?macro=true";
import { default as ProjectWorkspaceSupportersMergeListPageBsLkP05KbXMeta } from "/src/src/pages/projects/ui/ProjectWorkspaceSupportersMergeListPage.vue?macro=true";
import { default as ProjectWorkspaceSupportersOrganizationFormPageGeuRgd4P0LMeta } from "/src/src/pages/projects/ui/ProjectWorkspaceSupportersOrganizationFormPage.vue?macro=true";
import { default as ProjectWorkspaceSupportersPage2sBkHAtuIMMeta } from "/src/src/pages/projects/ui/ProjectWorkspaceSupportersPage.vue?macro=true";
import { default as ProjectWorkspaceSupportersSharePage5I0iB9eVhHMeta } from "/src/src/pages/projects/ui/ProjectWorkspaceSupportersSharePage.vue?macro=true";
import { default as EventApplicationApprovalPage7pN7b9Q4cZMeta } from "/src/src/pages/round-table/application/EventApplicationApprovalPage.vue?macro=true";
import { default as EventApplicationPageJLv5oN6aUnMeta } from "/src/src/pages/round-table/application/EventApplicationPage.vue?macro=true";
import { default as EventPassportEditPageK55LSqnnolMeta } from "/src/src/pages/round-table/passport/EventPassportEditPage.vue?macro=true";
import { default as EventPassportEntryPagetdBWmBGFDKMeta } from "/src/src/pages/round-table/passport/EventPassportEntryPage.vue?macro=true";
import { default as EventPassportParticipantsPageQMkNDTpotpMeta } from "/src/src/pages/round-table/passport/EventPassportParticipantsPage.vue?macro=true";
import { default as EventPassportViewPageZcJ0AqJn9GMeta } from "/src/src/pages/round-table/passport/EventPassportViewPage.vue?macro=true";
import { default as useObjectPassportMediaUpload7dHZhG69VSMeta } from "/src/src/pages/round-table/passport/model/useObjectPassportMediaUpload.ts?macro=true";
import { default as EventProgramEditPageS2GceitkbiMeta } from "/src/src/pages/round-table/program/EventProgramEditPage.vue?macro=true";
import { default as EventProgramEntryPageTGNa1667zHMeta } from "/src/src/pages/round-table/program/EventProgramEntryPage.vue?macro=true";
import { default as EventProgramViewPageTCDbl8rkrwMeta } from "/src/src/pages/round-table/program/EventProgramViewPage.vue?macro=true";
import { default as useEventProgramMediaUploadiZGLLWYYeTMeta } from "/src/src/pages/round-table/program/model/useEventProgramMediaUpload.ts?macro=true";
import { default as EventRegulationEditPageIN5HYTRKPDMeta } from "/src/src/pages/round-table/regulation/EventRegulationEditPage.vue?macro=true";
import { default as EventRegulationEntryPageJKxw82sKIRMeta } from "/src/src/pages/round-table/regulation/EventRegulationEntryPage.vue?macro=true";
import { default as EventRegulationViewPageVzkGlk8ZNHMeta } from "/src/src/pages/round-table/regulation/EventRegulationViewPage.vue?macro=true";
import { default as SecurityPagez6s9Hsj4UGMeta } from "/src/src/pages/security/ui/SecurityPage.vue?macro=true";
import { default as constHLpoU9ErwZMeta } from "/src/src/pages/shop/model/const.ts?macro=true";
import { default as ShopAdvertisingDetailPageYDmuLJVdCFMeta } from "/src/src/pages/shop/ui/ShopAdvertisingDetailPage.vue?macro=true";
import { default as ShopPageuZmMrJKFXbMeta } from "/src/src/pages/shop/ui/ShopPage.vue?macro=true";
import { default as ShopPointsPagelYBBZCi7wgMeta } from "/src/src/pages/shop/ui/ShopPointsPage.vue?macro=true";
import { default as const6H0uh11QwaMeta } from "/src/src/pages/surveys/model/const.ts?macro=true";
import { default as SurveyExportPopupXjo3SankdRMeta } from "/src/src/pages/surveys/ui/SurveyExportPopup.vue?macro=true";
import { default as SurveySavePopupWFGFQYy2EBMeta } from "/src/src/pages/surveys/ui/SurveySavePopup.vue?macro=true";
import { default as SurveysFillPagequlATx83DhMeta } from "/src/src/pages/surveys/ui/SurveysFillPage.vue?macro=true";
import { default as SurveysFormPage8WYo92NTLnMeta } from "/src/src/pages/surveys/ui/SurveysFormPage.vue?macro=true";
import { default as SurveysPageuRpjccTuv5Meta } from "/src/src/pages/surveys/ui/SurveysPage.vue?macro=true";
import { default as SurveysStatisticsPageyFnSitANjOMeta } from "/src/src/pages/surveys/ui/SurveysStatisticsPage.vue?macro=true";
import { default as SurveysStatisticsPrivatePage19VZMMKD6UMeta } from "/src/src/pages/surveys/ui/SurveysStatisticsPrivatePage.vue?macro=true";
import { default as SurveysStatisticsUserPagegV38linOPgMeta } from "/src/src/pages/surveys/ui/SurveysStatisticsUserPage.vue?macro=true";
import { default as UserBlock4hhwNi2MivMeta } from "/src/src/pages/user/ui/UserBlock.vue?macro=true";
import { default as UserPageqdkLQJ13cHMeta } from "/src/src/pages/user/ui/UserPage.vue?macro=true";
import { default as WorkspaceManagementModuleDetailPageBSDsgSdmKzMeta } from "/src/src/pages/workspace/ui/WorkspaceManagementModuleDetailPage.vue?macro=true";
import { default as WorkspacePage47vX6VfWqQMeta } from "/src/src/pages/workspace/ui/WorkspacePage.vue?macro=true";
export default [
  {
    name: "404-ui-404Page",
    path: "/404/ui/404Page",
    component: () => import("/src/src/pages/404/ui/404Page.vue")
  },
  {
    name: "address-ui-AddressPage",
    path: "/address/ui/AddressPage",
    component: () => import("/src/src/pages/address/ui/AddressPage.vue")
  },
  {
    name: "admin-permissions-ui-PermissionsPage",
    path: "/admin/permissions/ui/PermissionsPage",
    component: () => import("/src/src/pages/admin/permissions/ui/PermissionsPage.vue")
  },
  {
    name: "admin-reports-supporters-model-const",
    path: "/admin/reports/supporters/model/const",
    component: () => import("/src/src/pages/admin/reports/supporters/model/const.ts")
  },
  {
    name: "admin-reports-supporters-model-reports-const",
    path: "/admin/reports/supporters/model/reports-const",
    component: () => import("/src/src/pages/admin/reports/supporters/model/reports-const.ts")
  },
  {
    name: "admin-reports-supporters-ui-DetailReportsPage",
    path: "/admin/reports/supporters/ui/DetailReportsPage",
    component: () => import("/src/src/pages/admin/reports/supporters/ui/DetailReportsPage.vue")
  },
  {
    name: "admin-reports-supporters-ui-FormTemplatePage",
    path: "/admin/reports/supporters/ui/FormTemplatePage",
    component: () => import("/src/src/pages/admin/reports/supporters/ui/FormTemplatePage.vue")
  },
  {
    name: "admin-reports-supporters-ui-ProjectsReportPage",
    path: "/admin/reports/supporters/ui/ProjectsReportPage",
    component: () => import("/src/src/pages/admin/reports/supporters/ui/ProjectsReportPage.vue")
  },
  {
    name: "admin-reports-supporters-ui-ReportsPage",
    path: "/admin/reports/supporters/ui/ReportsPage",
    component: () => import("/src/src/pages/admin/reports/supporters/ui/ReportsPage.vue")
  },
  {
    name: "admin-reports-supporters-ui-SendMessagePage",
    path: "/admin/reports/supporters/ui/SendMessagePage",
    component: () => import("/src/src/pages/admin/reports/supporters/ui/SendMessagePage.vue")
  },
  {
    name: "admin-reports-supporters-ui-SupportersReportPage",
    path: "/admin/reports/supporters/ui/SupportersReportPage",
    component: () => import("/src/src/pages/admin/reports/supporters/ui/SupportersReportPage.vue")
  },
  {
    name: "admin-reports-supporters-ui-TemplateReport",
    path: "/admin/reports/supporters/ui/TemplateReport",
    component: () => import("/src/src/pages/admin/reports/supporters/ui/TemplateReport.vue")
  },
  {
    name: "admin-reports-supporters-ui-TemplatesReportPage",
    path: "/admin/reports/supporters/ui/TemplatesReportPage",
    component: () => import("/src/src/pages/admin/reports/supporters/ui/TemplatesReportPage.vue")
  },
  {
    name: "auth-forgot-password-ui-ForgotPasswordPage",
    path: "/auth/forgot-password/ui/ForgotPasswordPage",
    component: () => import("/src/src/pages/auth/forgot-password/ui/ForgotPasswordPage.vue")
  },
  {
    name: "auth-home-ui-HomePage",
    path: "/auth/home/ui/HomePage",
    component: () => import("/src/src/pages/auth/home/ui/HomePage.vue")
  },
  {
    name: "auth-pin-setup-ui-PinSetupPage",
    path: "/auth/pin-setup/ui/PinSetupPage",
    component: () => import("/src/src/pages/auth/pin-setup/ui/PinSetupPage.vue")
  },
  {
    name: "auth-pin-unlock-ui-PinUnlockPage",
    path: "/auth/pin-unlock/ui/PinUnlockPage",
    component: () => import("/src/src/pages/auth/pin-unlock/ui/PinUnlockPage.vue")
  },
  {
    name: "auth-profile-ui-ProfilePage",
    path: "/auth/profile/ui/ProfilePage",
    component: () => import("/src/src/pages/auth/profile/ui/ProfilePage.vue")
  },
  {
    name: "auth-set-password-ui-SetPasswordPage",
    path: "/auth/set-password/ui/SetPasswordPage",
    component: () => import("/src/src/pages/auth/set-password/ui/SetPasswordPage.vue")
  },
  {
    name: "auth-signin-ui-SigninPage",
    path: "/auth/signin/ui/SigninPage",
    component: () => import("/src/src/pages/auth/signin/ui/SigninPage.vue")
  },
  {
    name: "auth-signup-ui-SignupPage",
    path: "/auth/signup/ui/SignupPage",
    component: () => import("/src/src/pages/auth/signup/ui/SignupPage.vue")
  },
  {
    name: "auth-success-ui-SuccessPage",
    path: "/auth/success/ui/SuccessPage",
    component: () => import("/src/src/pages/auth/success/ui/SuccessPage.vue")
  },
  {
    name: "auth-verify-ui-VerifyPage",
    path: "/auth/verify/ui/VerifyPage",
    component: () => import("/src/src/pages/auth/verify/ui/VerifyPage.vue")
  },
  {
    name: "calendar-model-calendarTaskInvitationsFilter",
    path: "/calendar/model/calendarTaskInvitationsFilter",
    component: () => import("/src/src/pages/calendar/model/calendarTaskInvitationsFilter.ts")
  },
  {
    name: "calendar-model-calendarTaskInvitationsMock",
    path: "/calendar/model/calendarTaskInvitationsMock",
    component: () => import("/src/src/pages/calendar/model/calendarTaskInvitationsMock.ts")
  },
  {
    name: "calendar-ui-CalendarPage",
    path: "/calendar/ui/CalendarPage",
    component: () => import("/src/src/pages/calendar/ui/CalendarPage.vue")
  },
  {
    name: "calendar-ui-CalendarTaskCommentsPage",
    path: "/calendar/ui/CalendarTaskCommentsPage",
    component: () => import("/src/src/pages/calendar/ui/CalendarTaskCommentsPage.vue")
  },
  {
    name: "calendar-ui-CalendarTaskInvitationsFilterPopup",
    path: "/calendar/ui/CalendarTaskInvitationsFilterPopup",
    component: () => import("/src/src/pages/calendar/ui/CalendarTaskInvitationsFilterPopup.vue")
  },
  {
    name: "calendar-ui-CalendarTaskInvitationsPage",
    path: "/calendar/ui/CalendarTaskInvitationsPage",
    component: () => import("/src/src/pages/calendar/ui/CalendarTaskInvitationsPage.vue")
  },
  {
    name: "calendar-ui-CalendarTaskParticipantsPage",
    path: "/calendar/ui/CalendarTaskParticipantsPage",
    component: () => import("/src/src/pages/calendar/ui/CalendarTaskParticipantsPage.vue")
  },
  {
    name: "comments-model-useCommentsThread",
    path: "/comments/model/useCommentsThread",
    component: () => import("/src/src/pages/comments/model/useCommentsThread.ts")
  },
  {
    name: "comments-ui-CommentsPage",
    path: "/comments/ui/CommentsPage",
    component: () => import("/src/src/pages/comments/ui/CommentsPage.vue")
  },
  {
    name: "comments-ui-CommentsThreadPanel",
    path: "/comments/ui/CommentsThreadPanel",
    component: () => import("/src/src/pages/comments/ui/CommentsThreadPanel.vue")
  },
  {
    name: "docs-open-source-ui-OpenSourcePage",
    path: "/docs/open-source/ui/OpenSourcePage",
    meta: OpenSourcePageR62ipQyh5eMeta || {},
    component: () => import("/src/src/pages/docs/open-source/ui/OpenSourcePage.vue")
  },
  {
    name: "docs-reestr-po-ui-ReestrDocsPage",
    path: "/docs/reestr-po/ui/ReestrDocsPage",
    component: () => import("/src/src/pages/docs/reestr-po/ui/ReestrDocsPage.vue")
  },
  {
    name: "documents-model-const",
    path: "/documents/model/const",
    component: () => import("/src/src/pages/documents/model/const.ts")
  },
  {
    name: "documents-ui-DocumentsFormPage",
    path: "/documents/ui/DocumentsFormPage",
    component: () => import("/src/src/pages/documents/ui/DocumentsFormPage.vue")
  },
  {
    name: "documents-ui-DocumentsPage",
    path: "/documents/ui/DocumentsPage",
    component: () => import("/src/src/pages/documents/ui/DocumentsPage.vue")
  },
  {
    name: "forbidden-ui-ForbiddenPage",
    path: "/forbidden/ui/ForbiddenPage",
    component: () => import("/src/src/pages/forbidden/ui/ForbiddenPage.vue")
  },
  {
    name: "friends-model-const",
    path: "/friends/model/const",
    component: () => import("/src/src/pages/friends/model/const.ts")
  },
  {
    name: "friends-ui-FriendsPage",
    path: "/friends/ui/FriendsPage",
    component: () => import("/src/src/pages/friends/ui/FriendsPage.vue")
  },
  {
    name: "index-ui-IndexPage",
    path: "//ui/IndexPage",
    meta: IndexPage8GV9K0mUVjMeta || {},
    component: () => import("/src/src/pages/index/ui/IndexPage.vue")
  },
  {
    name: "internet-ui-InternetPage",
    path: "/internet/ui/InternetPage",
    component: () => import("/src/src/pages/internet/ui/InternetPage.vue")
  },
  {
    name: "legal-advertising",
    path: "/legal/advertising",
    component: () => import("/src/src/pages/legal/advertising/index.ts")
  },
  {
    name: "legal-advertising-ui-AdvertisingPage",
    path: "/legal/advertising/ui/AdvertisingPage",
    meta: AdvertisingPageO5EwjaR1QZMeta || {},
    component: () => import("/src/src/pages/legal/advertising/ui/AdvertisingPage.vue")
  },
  {
    name: "legal-consent",
    path: "/legal/consent",
    component: () => import("/src/src/pages/legal/consent/index.ts")
  },
  {
    name: "legal-consent-ui-ConsentPage",
    path: "/legal/consent/ui/ConsentPage",
    meta: ConsentPagenJuSme54sJMeta || {},
    component: () => import("/src/src/pages/legal/consent/ui/ConsentPage.vue")
  },
  {
    name: "legal-cookies",
    path: "/legal/cookies",
    component: () => import("/src/src/pages/legal/cookies/index.ts")
  },
  {
    name: "legal-cookies-ui-CookiesPage",
    path: "/legal/cookies/ui/CookiesPage",
    meta: CookiesPageobanI7ES6WMeta || {},
    component: () => import("/src/src/pages/legal/cookies/ui/CookiesPage.vue")
  },
  {
    name: "legal-privacy",
    path: "/legal/privacy",
    component: () => import("/src/src/pages/legal/privacy/index.ts")
  },
  {
    name: "legal-privacy-ui-PrivacyPage",
    path: "/legal/privacy/ui/PrivacyPage",
    meta: PrivacyPageZ8sRIVRMk7Meta || {},
    component: () => import("/src/src/pages/legal/privacy/ui/PrivacyPage.vue")
  },
  {
    name: "load-ui-LoadPage",
    path: "/load/ui/LoadPage",
    component: () => import("/src/src/pages/load/ui/LoadPage.vue")
  },
  {
    name: "mail-model-const",
    path: "/mail/model/const",
    component: () => import("/src/src/pages/mail/model/const.ts")
  },
  {
    name: "mail-model-useMailForm",
    path: "/mail/model/useMailForm",
    component: () => import("/src/src/pages/mail/model/useMailForm.ts")
  },
  {
    name: "mail-model-useMailItem",
    path: "/mail/model/useMailItem",
    component: () => import("/src/src/pages/mail/model/useMailItem.ts")
  },
  {
    name: "mail-model-useMailRecipients",
    path: "/mail/model/useMailRecipients",
    component: () => import("/src/src/pages/mail/model/useMailRecipients.ts")
  },
  {
    name: "mail-ui-MailAppealPage",
    path: "/mail/ui/MailAppealPage",
    component: () => import("/src/src/pages/mail/ui/MailAppealPage.vue")
  },
  {
    name: "mail-ui-MailCreatePage",
    path: "/mail/ui/MailCreatePage",
    component: () => import("/src/src/pages/mail/ui/MailCreatePage.vue")
  },
  {
    name: "mail-ui-MailDetailPage",
    path: "/mail/ui/MailDetailPage",
    component: () => import("/src/src/pages/mail/ui/MailDetailPage.vue")
  },
  {
    name: "mail-ui-MailPage",
    path: "/mail/ui/MailPage",
    component: () => import("/src/src/pages/mail/ui/MailPage.vue")
  },
  {
    name: "mail-ui-MailReplyPage",
    path: "/mail/ui/MailReplyPage",
    component: () => import("/src/src/pages/mail/ui/MailReplyPage.vue")
  },
  {
    name: "news-model-const",
    path: "/news/model/const",
    component: () => import("/src/src/pages/news/model/const.ts")
  },
  {
    name: "news-ui-MediaInsertField",
    path: "/news/ui/MediaInsertField",
    component: () => import("/src/src/pages/news/ui/MediaInsertField.vue")
  },
  {
    name: "news-ui-MySpeechReorderPage",
    path: "/news/ui/MySpeechReorderPage",
    component: () => import("/src/src/pages/news/ui/MySpeechReorderPage.vue")
  },
  {
    name: "news-ui-MySpeechReviewPage",
    path: "/news/ui/MySpeechReviewPage",
    component: () => import("/src/src/pages/news/ui/MySpeechReviewPage.vue")
  },
  {
    name: "news-ui-NewsDetailPage",
    path: "/news/ui/NewsDetailPage",
    component: () => import("/src/src/pages/news/ui/NewsDetailPage.vue")
  },
  {
    name: "news-ui-NewsFormPage",
    path: "/news/ui/NewsFormPage",
    component: () => import("/src/src/pages/news/ui/NewsFormPage.vue")
  },
  {
    name: "news-ui-NewsPage",
    path: "/news/ui/NewsPage",
    component: () => import("/src/src/pages/news/ui/NewsPage.vue")
  },
  {
    name: "news-ui-NewsSelectionProjectPage",
    path: "/news/ui/NewsSelectionProjectPage",
    component: () => import("/src/src/pages/news/ui/NewsSelectionProjectPage.vue")
  },
  {
    name: "notification-settings-ui-NotificationSettingsPage",
    path: "/notification-settings/ui/NotificationSettingsPage",
    component: () => import("/src/src/pages/notification-settings/ui/NotificationSettingsPage.vue")
  },
  {
    name: "notifications-model-const",
    path: "/notifications/model/const",
    component: () => import("/src/src/pages/notifications/model/const.ts")
  },
  {
    name: "notifications-ui-NotificationsPage",
    path: "/notifications/ui/NotificationsPage",
    component: () => import("/src/src/pages/notifications/ui/NotificationsPage.vue")
  },
  {
    name: "notifications-ui-PushNotificationsPage",
    path: "/notifications/ui/PushNotificationsPage",
    component: () => import("/src/src/pages/notifications/ui/PushNotificationsPage.vue")
  },
  {
    name: "profile-ui-ProfilePage",
    path: "/profile/ui/ProfilePage",
    component: () => import("/src/src/pages/profile/ui/ProfilePage.vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/src/src/pages/projects/index.ts")
  },
  {
    name: "projects-model-const",
    path: "/projects/model/const",
    component: () => import("/src/src/pages/projects/model/const.ts")
  },
  {
    name: "projects-model-filterManagementBuiltinModulesForProjectWorkspace",
    path: "/projects/model/filterManagementBuiltinModulesForProjectWorkspace",
    component: () => import("/src/src/pages/projects/model/filterManagementBuiltinModulesForProjectWorkspace.ts")
  },
  {
    name: "projects-model-projectsFilter",
    path: "/projects/model/projectsFilter",
    component: () => import("/src/src/pages/projects/model/projectsFilter.ts")
  },
  {
    name: "projects-model-projectsListScroll",
    path: "/projects/model/projectsListScroll",
    component: () => import("/src/src/pages/projects/model/projectsListScroll.ts")
  },
  {
    name: "projects-ui-ProfileMyTeamPage",
    path: "/projects/ui/ProfileMyTeamPage",
    component: () => import("/src/src/pages/projects/ui/ProfileMyTeamPage.vue")
  },
  {
    name: "projects-ui-ProjectEditPage",
    path: "/projects/ui/ProjectEditPage",
    component: () => import("/src/src/pages/projects/ui/ProjectEditPage.vue")
  },
  {
    name: "projects-ui-ProjectFormPage",
    path: "/projects/ui/ProjectFormPage",
    component: () => import("/src/src/pages/projects/ui/ProjectFormPage.vue")
  },
  {
    name: "projects-ui-ProjectLandingModuleSelectPage",
    path: "/projects/ui/ProjectLandingModuleSelectPage",
    component: () => import("/src/src/pages/projects/ui/ProjectLandingModuleSelectPage.vue")
  },
  {
    name: "projects-ui-ProjectPage",
    path: "/projects/ui/ProjectPage",
    component: () => import("/src/src/pages/projects/ui/ProjectPage.vue")
  },
  {
    name: "projects-ui-ProjectRequestApprovePage",
    path: "/projects/ui/ProjectRequestApprovePage",
    component: () => import("/src/src/pages/projects/ui/ProjectRequestApprovePage.vue")
  },
  {
    name: "projects-ui-ProjectsAllPage",
    path: "/projects/ui/ProjectsAllPage",
    component: () => import("/src/src/pages/projects/ui/ProjectsAllPage.vue")
  },
  {
    name: "projects-ui-ProjectsFavoritePage",
    path: "/projects/ui/ProjectsFavoritePage",
    component: () => import("/src/src/pages/projects/ui/ProjectsFavoritePage.vue")
  },
  {
    name: "projects-ui-ProjectsFilterPopup",
    path: "/projects/ui/ProjectsFilterPopup",
    component: () => import("/src/src/pages/projects/ui/ProjectsFilterPopup.vue")
  },
  {
    name: "projects-ui-ProjectsMyPage",
    path: "/projects/ui/ProjectsMyPage",
    component: () => import("/src/src/pages/projects/ui/ProjectsMyPage.vue")
  },
  {
    name: "projects-ui-ProjectsPage",
    path: "/projects/ui/ProjectsPage",
    component: () => import("/src/src/pages/projects/ui/ProjectsPage.vue")
  },
  {
    name: "projects-ui-ProjectsRequestsPage",
    path: "/projects/ui/ProjectsRequestsPage",
    component: () => import("/src/src/pages/projects/ui/ProjectsRequestsPage.vue")
  },
  {
    name: "projects-ui-ProjectsWorkspaceCountersDetailPage",
    path: "/projects/ui/ProjectsWorkspaceCountersDetailPage",
    component: () => import("/src/src/pages/projects/ui/ProjectsWorkspaceCountersDetailPage.vue")
  },
  {
    name: "projects-ui-ProjectsWorkspaceCountersHistoryPage",
    path: "/projects/ui/ProjectsWorkspaceCountersHistoryPage",
    component: () => import("/src/src/pages/projects/ui/ProjectsWorkspaceCountersHistoryPage.vue")
  },
  {
    name: "projects-ui-ProjectsWorkspaceCountersPage",
    path: "/projects/ui/ProjectsWorkspaceCountersPage",
    component: () => import("/src/src/pages/projects/ui/ProjectsWorkspaceCountersPage.vue")
  },
  {
    name: "projects-ui-ProjectsWorkspaceManagementModuleDetailPage",
    path: "/projects/ui/ProjectsWorkspaceManagementModuleDetailPage",
    component: () => import("/src/src/pages/projects/ui/ProjectsWorkspaceManagementModuleDetailPage.vue")
  },
  {
    name: "projects-ui-ProjectsWorkspaceManagementModulePage",
    path: "/projects/ui/ProjectsWorkspaceManagementModulePage",
    component: () => import("/src/src/pages/projects/ui/ProjectsWorkspaceManagementModulePage.vue")
  },
  {
    name: "projects-ui-ProjectsWorkspaceManagementMyTeamPage",
    path: "/projects/ui/ProjectsWorkspaceManagementMyTeamPage",
    component: () => import("/src/src/pages/projects/ui/ProjectsWorkspaceManagementMyTeamPage.vue")
  },
  {
    name: "projects-ui-ProjectsWorkspaceManagementSettingsPage",
    path: "/projects/ui/ProjectsWorkspaceManagementSettingsPage",
    component: () => import("/src/src/pages/projects/ui/ProjectsWorkspaceManagementSettingsPage.vue")
  },
  {
    name: "projects-ui-ProjectTemplatePage",
    path: "/projects/ui/ProjectTemplatePage",
    component: () => import("/src/src/pages/projects/ui/ProjectTemplatePage.vue")
  },
  {
    name: "projects-ui-ProjectWorkspaceEmergencyContactsCategoryPage",
    path: "/projects/ui/ProjectWorkspaceEmergencyContactsCategoryPage",
    component: () => import("/src/src/pages/projects/ui/ProjectWorkspaceEmergencyContactsCategoryPage.vue")
  },
  {
    name: "projects-ui-ProjectWorkspaceEmergencyContactsPage",
    path: "/projects/ui/ProjectWorkspaceEmergencyContactsPage",
    component: () => import("/src/src/pages/projects/ui/ProjectWorkspaceEmergencyContactsPage.vue")
  },
  {
    name: "projects-ui-ProjectWorkspaceMembersInvitePage",
    path: "/projects/ui/ProjectWorkspaceMembersInvitePage",
    component: () => import("/src/src/pages/projects/ui/ProjectWorkspaceMembersInvitePage.vue")
  },
  {
    name: "projects-ui-ProjectWorkspaceMembersPage",
    path: "/projects/ui/ProjectWorkspaceMembersPage",
    component: () => import("/src/src/pages/projects/ui/ProjectWorkspaceMembersPage.vue")
  },
  {
    name: "projects-ui-ProjectWorkspacePage",
    path: "/projects/ui/ProjectWorkspacePage",
    component: () => import("/src/src/pages/projects/ui/ProjectWorkspacePage.vue")
  },
  {
    name: "projects-ui-ProjectWorkspacePresetSelectPage",
    path: "/projects/ui/ProjectWorkspacePresetSelectPage",
    component: () => import("/src/src/pages/projects/ui/ProjectWorkspacePresetSelectPage.vue")
  },
  {
    name: "projects-ui-ProjectWorkspaceSupportersFormPage",
    path: "/projects/ui/ProjectWorkspaceSupportersFormPage",
    component: () => import("/src/src/pages/projects/ui/ProjectWorkspaceSupportersFormPage.vue")
  },
  {
    name: "projects-ui-ProjectWorkspaceSupportersMergeListPage",
    path: "/projects/ui/ProjectWorkspaceSupportersMergeListPage",
    component: () => import("/src/src/pages/projects/ui/ProjectWorkspaceSupportersMergeListPage.vue")
  },
  {
    name: "projects-ui-ProjectWorkspaceSupportersOrganizationFormPage",
    path: "/projects/ui/ProjectWorkspaceSupportersOrganizationFormPage",
    component: () => import("/src/src/pages/projects/ui/ProjectWorkspaceSupportersOrganizationFormPage.vue")
  },
  {
    name: "projects-ui-ProjectWorkspaceSupportersPage",
    path: "/projects/ui/ProjectWorkspaceSupportersPage",
    component: () => import("/src/src/pages/projects/ui/ProjectWorkspaceSupportersPage.vue")
  },
  {
    name: "projects-ui-ProjectWorkspaceSupportersSharePage",
    path: "/projects/ui/ProjectWorkspaceSupportersSharePage",
    component: () => import("/src/src/pages/projects/ui/ProjectWorkspaceSupportersSharePage.vue")
  },
  {
    name: "round-table-application-EventApplicationApprovalPage",
    path: "/round-table/application/EventApplicationApprovalPage",
    component: () => import("/src/src/pages/round-table/application/EventApplicationApprovalPage.vue")
  },
  {
    name: "round-table-application-EventApplicationPage",
    path: "/round-table/application/EventApplicationPage",
    component: () => import("/src/src/pages/round-table/application/EventApplicationPage.vue")
  },
  {
    name: "round-table-passport-EventPassportEditPage",
    path: "/round-table/passport/EventPassportEditPage",
    component: () => import("/src/src/pages/round-table/passport/EventPassportEditPage.vue")
  },
  {
    name: "round-table-passport-EventPassportEntryPage",
    path: "/round-table/passport/EventPassportEntryPage",
    component: () => import("/src/src/pages/round-table/passport/EventPassportEntryPage.vue")
  },
  {
    name: "round-table-passport-EventPassportParticipantsPage",
    path: "/round-table/passport/EventPassportParticipantsPage",
    component: () => import("/src/src/pages/round-table/passport/EventPassportParticipantsPage.vue")
  },
  {
    name: "round-table-passport-EventPassportViewPage",
    path: "/round-table/passport/EventPassportViewPage",
    component: () => import("/src/src/pages/round-table/passport/EventPassportViewPage.vue")
  },
  {
    name: "round-table-passport-model-useObjectPassportMediaUpload",
    path: "/round-table/passport/model/useObjectPassportMediaUpload",
    component: () => import("/src/src/pages/round-table/passport/model/useObjectPassportMediaUpload.ts")
  },
  {
    name: "round-table-program-EventProgramEditPage",
    path: "/round-table/program/EventProgramEditPage",
    component: () => import("/src/src/pages/round-table/program/EventProgramEditPage.vue")
  },
  {
    name: "round-table-program-EventProgramEntryPage",
    path: "/round-table/program/EventProgramEntryPage",
    component: () => import("/src/src/pages/round-table/program/EventProgramEntryPage.vue")
  },
  {
    name: "round-table-program-EventProgramViewPage",
    path: "/round-table/program/EventProgramViewPage",
    component: () => import("/src/src/pages/round-table/program/EventProgramViewPage.vue")
  },
  {
    name: "round-table-program-model-useEventProgramMediaUpload",
    path: "/round-table/program/model/useEventProgramMediaUpload",
    component: () => import("/src/src/pages/round-table/program/model/useEventProgramMediaUpload.ts")
  },
  {
    name: "round-table-regulation-EventRegulationEditPage",
    path: "/round-table/regulation/EventRegulationEditPage",
    component: () => import("/src/src/pages/round-table/regulation/EventRegulationEditPage.vue")
  },
  {
    name: "round-table-regulation-EventRegulationEntryPage",
    path: "/round-table/regulation/EventRegulationEntryPage",
    component: () => import("/src/src/pages/round-table/regulation/EventRegulationEntryPage.vue")
  },
  {
    name: "round-table-regulation-EventRegulationViewPage",
    path: "/round-table/regulation/EventRegulationViewPage",
    component: () => import("/src/src/pages/round-table/regulation/EventRegulationViewPage.vue")
  },
  {
    name: "security-ui-SecurityPage",
    path: "/security/ui/SecurityPage",
    component: () => import("/src/src/pages/security/ui/SecurityPage.vue")
  },
  {
    name: "shop-model-const",
    path: "/shop/model/const",
    component: () => import("/src/src/pages/shop/model/const.ts")
  },
  {
    name: "shop-ui-ShopAdvertisingDetailPage",
    path: "/shop/ui/ShopAdvertisingDetailPage",
    component: () => import("/src/src/pages/shop/ui/ShopAdvertisingDetailPage.vue")
  },
  {
    name: "shop-ui-ShopPage",
    path: "/shop/ui/ShopPage",
    component: () => import("/src/src/pages/shop/ui/ShopPage.vue")
  },
  {
    name: "shop-ui-ShopPointsPage",
    path: "/shop/ui/ShopPointsPage",
    component: () => import("/src/src/pages/shop/ui/ShopPointsPage.vue")
  },
  {
    name: "surveys-model-const",
    path: "/surveys/model/const",
    component: () => import("/src/src/pages/surveys/model/const.ts")
  },
  {
    name: "surveys-ui-SurveyExportPopup",
    path: "/surveys/ui/SurveyExportPopup",
    component: () => import("/src/src/pages/surveys/ui/SurveyExportPopup.vue")
  },
  {
    name: "surveys-ui-SurveySavePopup",
    path: "/surveys/ui/SurveySavePopup",
    component: () => import("/src/src/pages/surveys/ui/SurveySavePopup.vue")
  },
  {
    name: "surveys-ui-SurveysFillPage",
    path: "/surveys/ui/SurveysFillPage",
    component: () => import("/src/src/pages/surveys/ui/SurveysFillPage.vue")
  },
  {
    name: "surveys-ui-SurveysFormPage",
    path: "/surveys/ui/SurveysFormPage",
    component: () => import("/src/src/pages/surveys/ui/SurveysFormPage.vue")
  },
  {
    name: "surveys-ui-SurveysPage",
    path: "/surveys/ui/SurveysPage",
    component: () => import("/src/src/pages/surveys/ui/SurveysPage.vue")
  },
  {
    name: "surveys-ui-SurveysStatisticsPage",
    path: "/surveys/ui/SurveysStatisticsPage",
    component: () => import("/src/src/pages/surveys/ui/SurveysStatisticsPage.vue")
  },
  {
    name: "surveys-ui-SurveysStatisticsPrivatePage",
    path: "/surveys/ui/SurveysStatisticsPrivatePage",
    component: () => import("/src/src/pages/surveys/ui/SurveysStatisticsPrivatePage.vue")
  },
  {
    name: "surveys-ui-SurveysStatisticsUserPage",
    path: "/surveys/ui/SurveysStatisticsUserPage",
    component: () => import("/src/src/pages/surveys/ui/SurveysStatisticsUserPage.vue")
  },
  {
    name: "user-ui-UserBlock",
    path: "/user/ui/UserBlock",
    component: () => import("/src/src/pages/user/ui/UserBlock.vue")
  },
  {
    name: "user-ui-UserPage",
    path: "/user/ui/UserPage",
    component: () => import("/src/src/pages/user/ui/UserPage.vue")
  },
  {
    name: "workspace-ui-WorkspaceManagementModuleDetailPage",
    path: "/workspace/ui/WorkspaceManagementModuleDetailPage",
    component: () => import("/src/src/pages/workspace/ui/WorkspaceManagementModuleDetailPage.vue")
  },
  {
    name: "workspace-ui-WorkspacePage",
    path: "/workspace/ui/WorkspacePage",
    component: () => import("/src/src/pages/workspace/ui/WorkspacePage.vue")
  }
]